/* eslint-disable no-nested-ternary */
import { useCallback, useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import * as Progress from 'react-native-progress';
import { Text, View } from '../Themed';

export type ProgressBarScreenParamList = {
  questionCategory: string;
  blurb: string[];
  duration: number;
  onSubmit?: (response: any) => void;
};

export default function ProgressBarScreen(props: ProgressBarScreenParamList) {
  const { questionCategory, blurb, duration, onSubmit } = props;

  console.log(questionCategory);

  const handleSubmit = useCallback(() => {
    if (typeof onSubmit === 'function') {
      onSubmit('SURVEY_NO_RESPONSE');
    }
  }, [onSubmit]); // prevents unnecessary renders

  const durationMs = duration * 1000;
  const timeoutRef: NodeJS.Timeout = setTimeout(handleSubmit, durationMs);
  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef);
    };
  }, [timeoutRef]);

  return (
    <View style={styles.container}>
      <View style={styles.textWrapper}>
        {blurb.map((val, ix, arr) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <Text key={`blurb_${ix}`} style={styles.blurbText}>
              {val}
            </Text>
          );
        })}
      </View>

      <Progress.Bar color="#008046" width={300} height={20} indeterminate indeterminateAnimationDuration={durationMs} />
    </View>
  );
}
ProgressBarScreen.defaultProps = {
  onSubmit: () => {},
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignSelf: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  textWrapper: {
    // height: 168,
    width: 300,
    marginBottom: 20,
  },
  promptText: {
    fontSize: 20,
    lineHeight: 24,
    fontWeight: '700',
    letterSpacing: 0,
    color: '#14181B',
  },
  promptContainer: {
    maxWidth: 300,
    alignSelf: 'center',
    marginBottom: 30,
  },
  buttonWrapper: {
    borderRadius: 21,
    width: 300,
    height: 50,
    marginVertical: 40,
    alignSelf: 'center',
  },
  buttonText: {
    fontSize: 20,
    fontWeight: '600',
    lineHeight: 25,
    letterSpacing: -0.29,
    color: '#F8F5F4',
  },
  blurbText: {
    color: '#14181B',
    paddingVertical: 10,
    fontSize: 20,
    fontWeight: '500',
    letterSpacing: 0,
    lineHeight: 24,
  },
  imageContainer: {
    backgroundColor: '#fff',
    shadowOpacity: 0.3,
    shadowRadius: 6,
    shadowOffset: {
      height: 3,
      width: 3,
    },
    margin: 30,
    padding: 10,
  },
});
